module.exports = __webpack_public_path__ + "img/1 to 9-incomes-and-expenses.1ce52b7d.svg";